import { memo, useCallback } from "react";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";

export interface ConfirmDeleteQuestionnaireDialogProps {
  open: boolean;
  title?: string;
  isConfirming?: boolean;
  errorMessage?: string;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

const ConfirmDeleteQuestionnaireDialog = memo(
  ({
    open,
    title,
    isConfirming = false,
    errorMessage,
    onClose,
    onConfirm,
  }: ConfirmDeleteQuestionnaireDialogProps) => {
    const handleConfirm = useCallback(async () => {
      try {
        await onConfirm();
      } catch {
        // O erro já é exibido via `errorMessage` fornecido pelo hook.
        // Aqui evitamos "unhandled promise rejection".
      }
    }, [onConfirm]);

    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
        <DialogTitle>Confirmar exclusão</DialogTitle>

        <DialogContent dividers>
          <Typography variant="body2">
            Tem certeza que deseja excluir este questionário?
            {title ? (
              <>
                {" "}
                <strong>{title}</strong>
              </>
            ) : null}
            {" "}
            Essa ação não pode ser desfeita.
          </Typography>

          {errorMessage ? (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errorMessage}
            </Alert>
          ) : null}
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} disabled={isConfirming}>
            Cancelar
          </Button>
          <Button
            onClick={handleConfirm}
            variant="contained"
            color="error"
            disabled={isConfirming}
          >
            Excluir
          </Button>
        </DialogActions>
      </Dialog>
    );
  },
);

ConfirmDeleteQuestionnaireDialog.displayName =
  "ConfirmDeleteQuestionnaireDialog";

export default ConfirmDeleteQuestionnaireDialog;

